<div (click)="toggleClick()" class="toggle-link-wrapper">
	<span class="toggle-text">{{
		isToggled ? textWhenToggled : textWhenUntoggled
	}}</span>
	<i
		[ngClass]="{ toggled: isToggled }"
		class="fa fa-angle-down toggle-arrow"
		tabindex="-1"
	></i>
</div>
